module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-title"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Acknowledgement"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Abbreviations"
    }
  }, [_vm._v("List of Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-h"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1")]), _vm._v("  Competitive Memory in the Great Lakes: Touring Genocide")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-h"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("2")]), _vm._v("  Marketing Trauma and the Theatre of War in Northern Uganda")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-h"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("3")]), _vm._v("  Trauma, Inc. in Postgenocide Rwanda")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-h"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("4")]), _vm._v("  Repetition, Rupture, and "), _c('i', [_vm._v("Ruined")]), _vm._v(": Narratives from the Congo")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-h"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("5")]), _vm._v("  Gifted by Trauma: The Branding of Postconflict Northern Uganda")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-h"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("6")]), _vm._v("  Confessions of a Failed Theatre Activist")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Afterword",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword: Faustin Linyekula and the Labors of Hope")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_References",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Abouttheauthor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03d5d562","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Contents.vue
// module id = 75
// module chunks = 0